<div class="flex flex-column align-items-center my-3">
  <div class="text-900 text-2xl font-medium mb-3 white">
    Data Privacy Agreement
  </div>
  <div class="align-items-start flex flex-column">
    <span class="mt-3 text-sm white">
      As part of our commitment to transparency and compliance, we kindly
      request you to review and provide your consent before proceeding:
    </span>
    <span class="mt-3 text-sm white">
      <b>Data Privacy Overview:</b> At PreMO, we prioritize the protection of
      your personal information. We collect and process certain data to
      provide you with an optimal experience:
    </span>
    <span class="mt-3 text-sm white pl-3">
      • <b>Personal Information:</b> Including your name and email
      address<br /><br />
      • <b>Organisation Information:</b> Including your organisation name, address, contact details, country and
      timezone<br /><br />
      • <b>Usage Statistics:</b> Such as navigation patterns and time spent
      on pages and crash reports (Optional)<br />
    </span>
    <span class="mt-3 text-sm white">
      These details are essential for account management, service
      improvement, and ensuring compliance with legal obligations. For
      comprehensive details on how we manage your information, please review
      our <a href="https://www.wolffsohnresearch.com/premo-privacy-policy" class="white" target="_blank">Privacy
        Policy</a>.
    </span>
    <span class="mt-3 text-sm white">
      <b>Consent Provision: </b> Please indicate your acknowledgment below:
    </span>
  </div>
  <div class="flex flex-column align-self-start justify-content-start mt-3 text-sm white gap-3" [formGroup]="formGroup">
    <!-- Required Data Collection Consent -->
    <div class="flex flex-row gap-2 align-items-start">
      <p-checkbox name="data" formControlName="data" [ngClass]="{
          'border-red':
            formGroup.get('data')?.dirty && formGroup.get('data')?.invalid
        }" [binary]="true" />
      <span>
        <b>Personal Data for Signup and User Terms Agreement</b> - Your email address, name and
        organisation are used for log in purposes only and you will abide by our <a
          href="https://www.wolffsohnresearch.com/premo-terms-and-conditions" class="white" target="_blank">Terms &
          Conditions</a>. For more information on how we use your data, view our <a
          href="https://www.wolffsohnresearch.com/premo-privacy-policy" class="white" target="_blank">Privacy
          Policy</a>.
      </span>
    </div>

    <!-- Marketing Communications Consent -->
    <div class="flex flex-row gap-2 align-items-start">
      <p-checkbox name="marketing" formControlName="marketing" [binary]="true">
      </p-checkbox>
      <span>
        <b>Data Controller and Processor Agreement</b> -
        As the data controller, you are responsible for any patient data you
        input into our system. By clicking "I Agree", you acknowledge your
        responsibilities under GDPR and agree to the terms set out in our
        <a href="https://www.wolffsohnresearch.com/premodataprocessingagreement" class="white" target="_blank">Data
          Processing Agreement</a>.

        At PreMO, we process patient data exclusively on your behalf. Unless
        specifically requested otherwise, the data is strictly processed for
        the sole purpose of generating a Myopia risk calculation.
        Additionally, we anonymise and aggregate the data to share with
        industrial partners, solely for evaluating the effectiveness of their
        treatments across different user groups.
      </span>
    </div>

    <!-- Analytics and Tracking Consent -->
    <div class="flex flex-row gap-2 align-items-start">
      <p-checkbox name="analytics" formControlName="analytics" [binary]="true">
      </p-checkbox>
      <span>
        <b>Optional Data Collection for Product Improvement and Feedback</b> -
        We'd like to collect additional data to improve our services,
        including screen taps, time spent on screens, and general usage data.
        We may also occasionally contact you to understand how you're using
        the app. Participation is optional.
      </span>
    </div>

    <div *ngIf="formGroup.errors?.['custom']" class="text-red-400 mt-2">
      {{
      formGroup.errors?.['custom']
      }}
    </div>
  </div>
</div>